import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { FormControl } from '@angular/forms';
import { ToasterService } from 'angular2-toaster';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';

@Component({
    selector: 'not-response-report-tab',
    templateUrl: './notResponseReport.component.html',
})
export class NotResponseReportComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;

    @ViewChild('trackTemplate') trackTemplate: TemplateRef<any>;
    @ViewChild('folTypeTemplate') folTypeTemplate: TemplateRef<any>;
    @ViewChild('daysTemplate') daysTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('colHeaderTpl') colHeaderTpl: TemplateRef<any>;

    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });

    isLoadMask: Promise<any>;
    loadingIndicator = true;

    usertype = '';
    branchList: any[] = [];
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    teamCtrl: FormControl;
    filteredTeams: Observable<any[]>;
    followupTeams: any[] = [];

    filterData: any = {
        search_data: '',
        from_date: new Date(),
        to_date: new Date(),
        team_id: 4,
        branch_id: '',
    };
    noDateFilter = false;

    page = { limit: 25, count: 0, offset: 0 };

    columns = [];
    reportData: any[] = [];
    filteredData: any[] = [];
    allColumns: any[] = [];

    // Column inline filters (Excel-style)
    columnFilters: { [prop: string]: string[] | undefined } = {};
    columnAllValues: { [prop: string]: string[] } = {};
    columnFilterSearch: { [prop: string]: string } = {};
    activeFilterProp: string | null = null;
    filterDropdownPos = { top: 0, left: 0 };
    private _colFilterClickHandled = false;

    // Column visibility toggle
    columnVisibility: { [prop: string]: boolean } = {};
    showColToggle = false;
    private _colToggleClickHandled = false;

    constructor(
        private http: Http,
        private toasterService: ToasterService,
        private store: Store<fromRootStore.State>
    ) {}

    displayFn(branchId: any) {
        if (branchId && this.branchList.length > 0) {
            const b = this.branchList.find((br: any) => br.branch_id == branchId);
            return b ? b.branch_name : '';
        }
        return '';
    }

    displayTeamFn(teamId: any) {
        if (teamId && this.followupTeams.length > 0) {
            const t = this.followupTeams.find((tm: any) => tm.team_id == teamId);
            return t ? t.team_name : '';
        }
        return '';
    }

    ngOnInit() {
        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map((name: any) => name && typeof name === 'string'
                ? this.branchList.filter(b => new RegExp(name, 'gi').test(b.branch_name))
                : this.branchList.slice());
        this.teamCtrl = new FormControl(4);
        this.filteredTeams = this.teamCtrl.valueChanges
            .startWith(4)
            .map((name: any) => name && typeof name === 'string'
                ? this.followupTeams.filter(t => new RegExp(name, 'gi').test(t.team_name))
                : this.followupTeams.slice());
        this.store.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            if (auth['islogin']) {
                this.usertype = auth['usertype'];
                if (auth['usertype'] !== 'Super_Admin' && auth['usertype'] !== 'Admin' && auth['usertype'] !== 'Accounts') {
                    this.filterData.branch_id = auth['branch_id'];
                    this.branchCtrl.disable();
                }
            }
        });
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (!res || !res.data) { return; }
            this.branchList = res.data;
        });

        this.loadFollowupTeams();
        this.getList();
    }

    ngOnChanges() { }

    loadFollowupTeams() {
        const options = new RequestOptions({ headers: this.headers });
        this.http.get('api/notResponseReport/getFollowupTeams', options)
            .toPromise()
            .then((res: any) => {
                this.followupTeams = res.json().data || [];
                // Re-emit current value so filteredTeams and displayWith refresh after async load
                this.teamCtrl.setValue(this.teamCtrl.value);
            })
            .catch(() => {});
    }

    pageCallback(pageInfo: any) {
        const newOffset = pageInfo.offset !== undefined ? pageInfo.offset : (pageInfo.page - 1);
        this.page.offset = newOffset;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    applyFilter() {
        this.page.offset = 0;
        this.filterPanel.close();
        this.columnFilters = {};
        this.columnFilterSearch = {};
        this.activeFilterProp = null;
        this.getList();
    }

    clearFilter() {
        this.filterData = { search_data: '', from_date: new Date(), to_date: new Date(), team_id: 4, branch_id: '' };
        this.noDateFilter = false;
        this.branchCtrl.setValue('');
        this.teamCtrl.setValue(4);
        this.applyFilter();
    }

    @HostListener('document:click')
    closeDropdowns() {
        if (this._colFilterClickHandled) { this._colFilterClickHandled = false; return; }
        if (this._colToggleClickHandled) { this._colToggleClickHandled = false; return; }
        this.activeFilterProp = null;
        this.showColToggle = false;
    }

    openColToggle(event: MouseEvent) {
        event.stopPropagation();
        this._colToggleClickHandled = true;
        this.showColToggle = !this.showColToggle;
        this.activeFilterProp = null;
    }

    toggleColumnVisibility(prop: string) {
        this.columnVisibility[prop] = !this.columnVisibility[prop];
        this.columns = this.allColumns.filter(c => this.columnVisibility[c.prop] !== false);
        this._applyColumnFilters();
    }

    toggleColumnFilter(event: MouseEvent, prop: string) {
        event.stopPropagation();
        this._colFilterClickHandled = true;
        this.showColToggle = false;
        if (this.activeFilterProp === prop) { this.activeFilterProp = null; return; }
        const target = event.target as HTMLElement;
        const rect = target.getBoundingClientRect();
        this.filterDropdownPos = { top: rect.bottom + 4, left: Math.max(4, rect.left - 80) };
        this.activeFilterProp = prop;
    }

    hasActiveFilter(prop: string): boolean {
        const sel = this.columnFilters[prop];
        return sel !== undefined && sel.length < (this.columnAllValues[prop] || []).length;
    }

    isAllSelected(prop: string): boolean {
        const sel = this.columnFilters[prop];
        return sel === undefined || sel.length === (this.columnAllValues[prop] || []).length;
    }

    isValueChecked(prop: string, val: string): boolean {
        const sel = this.columnFilters[prop];
        return sel === undefined || sel.indexOf(val) >= 0;
    }

    toggleSelectAll(prop: string) {
        if (this.isAllSelected(prop)) {
            this.columnFilters[prop] = [];
        } else {
            delete this.columnFilters[prop];
        }
        this._applyColumnFilters();
    }

    toggleFilterValue(prop: string, val: string) {
        const allVals = this.columnAllValues[prop] || [];
        let sel = this.columnFilters[prop];
        if (sel === undefined) {
            sel = allVals.filter(v => v !== val);
        } else {
            const idx = sel.indexOf(val);
            if (idx >= 0) {
                sel = sel.filter(v => v !== val);
            } else {
                sel = sel.concat([val]);
                if (sel.length === allVals.length) { delete this.columnFilters[prop]; this._applyColumnFilters(); return; }
            }
        }
        this.columnFilters[prop] = sel;
        this._applyColumnFilters();
    }

    getDropdownValues(prop: string): string[] {
        const search = (this.columnFilterSearch[prop] || '').toLowerCase();
        const vals = this.columnAllValues[prop] || [];
        return search ? vals.filter(v => v.toLowerCase().indexOf(search) >= 0) : vals;
    }

    hasAnyColumnFilter(): boolean {
        return Object.keys(this.columnFilters).some(p => {
            const sel = this.columnFilters[p];
            return sel !== undefined && sel.length < (this.columnAllValues[p] || []).length;
        });
    }

    clearAllColumnFilters() {
        this.columnFilters = {};
        this.columnFilterSearch = {};
        this.activeFilterProp = null;
        this._applyColumnFilters();
    }

    private _buildAllValues() {
        this.columnAllValues = {};
        this.columns.forEach((col: any) => {
            const vals: { [k: string]: boolean } = {};
            this.reportData.forEach(row => { vals[String(row[col.prop] == null ? '' : row[col.prop])] = true; });
            this.columnAllValues[col.prop] = Object.keys(vals).sort();
        });
    }

    private _applyColumnFilters() {
        this.filteredData = this.reportData.filter(row =>
            Object.keys(this.columnFilters).every(prop => {
                const sel = this.columnFilters[prop];
                if (sel === undefined) return true;
                return sel.indexOf(String(row[prop] == null ? '' : row[prop])) >= 0;
            })
        );
    }

    buildParams(start: number, limit: number): URLSearchParams {
        const p = new URLSearchParams();
        p.set('start', `${start}`);
        p.set('limit', `${limit}`);
        p.set('search_data', this.filterData.search_data || '');
        if (!this.noDateFilter) {
            if (this.filterData.from_date) { p.set('from_date', moment(this.filterData.from_date).format('YYYY-MM-DD')); }
            if (this.filterData.to_date)   { p.set('to_date',   moment(this.filterData.to_date).format('YYYY-MM-DD')); }
        }
        if (this.filterData.team_id)   { p.set('team_id',   this.filterData.team_id); }
        if (this.filterData.branch_id) { p.set('branch_id', this.filterData.branch_id); }
        return p;
    }

    downloadExcel() {
        const p = this.buildParams(0, 0);
        window.open(`api/notResponseReport/exportExcel?${p.toString()}`, '_blank');
    }

    getList() {
        const options = new RequestOptions({
            headers: this.headers,
            search: this.buildParams(this.page.offset, this.page.limit)
        });
        this.isLoadMask = this.http.get('api/notResponseReport/getList', options)
            .toPromise()
            .then((res: any) => {
                const body = res.json();
                this.loadingIndicator = false;
                this.page.count = body.totCnt || 0;
                this.reportData = body.data   || [];
                if (body.columns && !this.allColumns.length) {
                    const templateMap: any = {
                        days_count:   this.daysTemplate,
                        fol_type:     this.folTypeTemplate,
                        no_of_follow: this.trackTemplate,
                    };
                    const isAdmin = this.usertype === 'Admin' || this.usertype === 'Super_Admin';
                    this.allColumns = body.columns
                        .filter((c: any) => !c.adminOnly || isAdmin)
                        .map((c: any) => {
                            const col: any = { name: c.name, prop: c.prop, width: c.width, minWidth: c.minWidth, maxWidth: c.maxWidth, sortable: c.sortable };
                            if (c.useTemplate && templateMap[c.prop]) { col.cellTemplate = templateMap[c.prop]; }
                            return col;
                        });
                    if (Object.keys(this.columnVisibility).length === 0) {
                        this.allColumns.forEach(c => { this.columnVisibility[c.prop] = true; });
                    }
                }
                // Apply header template on every load (colHeaderTpl ready after view init)
                if (this.colHeaderTpl) {
                    this.allColumns.forEach(col => { col.headerTemplate = this.colHeaderTpl; });
                }
                this.columns = this.allColumns.filter(c => this.columnVisibility[c.prop] !== false);
                this._buildAllValues();
                this._applyColumnFilters();
            })
            .catch(() => {
                this.loadingIndicator = false;
                this.toasterService.pop('error', 'Error', 'Failed to load report');
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/notResponseReport/notResponseReport.component.ts